// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { FullTextToolTip } from 'ui_kit_qmd'
import './InfoCard.scss'
import { text } from '../../Constants'
import upIcon from '../../../../../images/common/chevronUp.png'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const InfoCard = ({ id, title, info, isTooltipOutside, hasArrowIcon, linkTo, extraStyle = {} }) => {
  const [isOnHoverPopUp, setIsOnHoverPopUp] = useState(false)

  useEffect(() => {
    // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
    info.map((label, index) => {
      // @ts-expect-error TS2531 -- MIGRATION: not approved, fix when encountered
      document.getElementById(id + index).addEventListener('mouseleave', () => setIsOnHoverPopUp(false))
      // @ts-expect-error TS2531 -- MIGRATION: not approved, fix when encountered
      document.getElementById(id + index).addEventListener('mouseover', () => setIsOnHoverPopUp(true))
    })
  }, [isOnHoverPopUp])

  const infoCardContainerStyle = {
    marginTop: title === text.EMERGENCY_CONTACT ? 16 : 0,
    overflow: isTooltipOutside ? 'visible' : 'hidden',
    ...extraStyle,
  }

  return (
    <div className='info-card-container-wrap' id={id} style={infoCardContainerStyle}>
      <div className='info-card-container'>
        {title ?
          <div className='info-title-container'>
            <span className='info-card-full-name bold'>{`${title}`}</span>
          </div>
        : null}
        {/*
         // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered */}
        {info.map((label, index) => (
          <div style={{ display: 'flex', width: '100%', position: 'relative' }}>
            <FullTextToolTip
              id={id + index}
              fullText={label.value}
              extraStyle={{ bottom: -35, left: '0px', zIndex: 900000, pointerEvents: 'none' }}
              view={
                <span
                  id={id + index}
                  className={label.textClassName ? `info-label ${label.textClassName}` : 'info-label'}>
                  <div />
                  {label.text}
                </span>
              }
            />
          </div>
        ))}
      </div>
      {hasArrowIcon ?
        <Link to={linkTo} className='info-card-arrow-icon-container'>
          <img src={upIcon} className='info-card-arrow-icon' alt='leftArrow' />
        </Link>
      : null}
    </div>
  )
}
